import type { FC } from 'react';

import { HelpChapterProps } from '../../../../api/fetchers/help/fetcher';
import { HelpText } from '../../utils/HelpText';

export const HelpChapterNoRollSituations: FC<HelpChapterProps> = ({ content }) => {
  if (!content) return null;

  return (
    <div>
      <p>
        <HelpText>{String(content.validRoll)}</HelpText>
      </p>
      <p>
        <HelpText>{String(content.notValidRoll)}</HelpText>
      </p>
      <p>
        <HelpText>{String(content.noRollSituation)}</HelpText>
      </p>
      <ul>
        <li>
          <HelpText>{String(content.noRoll1)}</HelpText>
        </li>
        <li>
          <HelpText>{String(content.noRoll2)}</HelpText>
        </li>
        <li>
          <HelpText>{String(content.noRoll3)}</HelpText>
        </li>
        <li>
          <HelpText>{String(content.noRoll4)}</HelpText>
        </li>
      </ul>
      <p>
        <HelpText>{String(content.reRollActivation)}</HelpText>
      </p>
      <p>
        <HelpText>{String(content.betsRemain)}</HelpText>
      </p>
    </div>
  );
};
